import React from 'react';
import {
    Button,
    Input,
    ListGroup,
    ListGroupItem,
    ListGroupItemHeading, ListGroupItemText,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Table
} from 'reactstrap';
import {setTitle} from './util';
import mfgFetch from './mfg-fetch';

const ADD_LABEL = "Add Practice";
const UPDATE_LABEL = "Update Practice";

class AdminBilling extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            practices: [],
            new_practice_id: "",
            new_practice_locations: "0",
            new_practice_setup_paid: "0",
            new_practice_do_not_bill: "0",
            practiceButtonLabel: ADD_LABEL,
            historyModalState: false,
            practiceHistory: false,

            filter_practice_id: "",
        };

        this.billNewPractice = this.billNewPractice.bind(this);
        this.toggleHistoryModal = this.toggleHistoryModal.bind(this);
    }

    componentDidMount() {
        setTitle("Billing");

        this.loadPractices();
    }

    toggleHistoryModal() { // toggle open content window
        this.setState(prevState => ({
            historyModalState: !prevState.historyModalState,
        }));
    }


    loadPractices() {
        this.getLinkedPractices()
            .then(practices => {
                if (practices) {
                    this.setState({
                        practices: practices
                    });
                }
            });
    }

    async getLinkedPractices() {
        let resp = await mfgFetch("/api/v1/admin/billing-practices", {
            method: "GET"
        });

        if (!resp || !resp.ok) {
            console.error("Invalid status " + resp.statusText + ': ' + await resp.text());
            return null;
        }

        return await resp.json();
    }

    handleChange(e) {
        this.setState({[e.target.name]: e.target.value});

        let label = ADD_LABEL;
        if (e.target.name === "new_practice_id") {

            this.setState({
                filter_practice_id: e.target.value
            });

            for (let practice of this.state.practices) {
                if (parseInt(e.target.value) === practice.practice_id) {
                    label = UPDATE_LABEL;
                    break;
                }
            }
            this.setState({
                practiceButtonLabel: label
            });

        }
    }

    handlePracticeClick(e) {
        this.setState({
            new_practice_id: e.currentTarget.dataset.practiceId,
            new_practice_locations: e.currentTarget.dataset.practiceLocations,
            new_practice_setup_paid: e.currentTarget.dataset.practiceSetupPaid,
            new_practice_do_not_bill: e.currentTarget.dataset.practiceDoNotBill,
            filter_practice_id: e.currentTarget.dataset.practiceId,
        });

        this.setState({
            practiceButtonLabel: UPDATE_LABEL,
        });

    }

    async addNewPractice() {
        let resp = await mfgFetch('/api/v1/admin/billing-practice-update', {
            method: 'POST',
            body: JSON.stringify({
                practice_id: parseInt(this.state.new_practice_id),
                locations: parseInt(this.state.new_practice_locations),
                setup_paid: parseInt(this.state.new_practice_setup_paid),
                do_not_bill: parseInt(this.state.new_practice_do_not_bill),
                subscription_start_date: 'now',
            })
        });

        if (!resp || !resp.ok) {
            console.error('Invalid status ' + resp.statusText + ': ' + await resp.text());
            return false;
        }

        return true;
    }

    async unsubscribePractice(practiceId) {
        let resp = await mfgFetch('/api/v1/admin/billing-practice-remove', {
            method: 'POST',
            body: JSON.stringify({
                practice_id: parseInt(practiceId),
            })
        });

        if (!resp || !resp.ok) {
            console.error('Invalid status ' + resp.statusText + ': ' + await resp.text());
            return false
        }

        return true;
    }

    billNewPractice() {
        if (this.state.new_practice_id === "") {
            return;
        }
        this.addNewPractice()
            .then(result => {
            if (result) {
                this.loadPractices();
            } else {
                console.error('Could not add new practice to be billed.');
            }
        });
    }



    handlePracticeUnsubscribeClick(e) {
        let practiceId = e.currentTarget.dataset.practiceId;

        this.setState({
            practices: [],
        });

        this.unsubscribePractice(practiceId)
            .then(result => {
                if (result) {
                    this.setState({
                        practiceButtonLabel: ADD_LABEL,

                    });
                    this.loadPractices();
                } else {
                    console.error('Could not remove practice subscription.');
                }
            });
    }

    handlePracticeHistoryClick(practice) {
        this.setState({
           practiceHistory: practice,
        });
        this.toggleHistoryModal();
    }

    render() {
        let billablePractices = [];

        for (let practice of this.state.practices) {

            if (!practice.practice_id.toString().includes(this.state.filter_practice_id)) {
                continue;
            }

            let subDate = new Date(practice.subscription_start_date);
            let locale = window.navigator.userLanguage || window.navigator.language || "en-US";

            let pName = 'Practice #' + practice.practice_id;
            if (practice.hasOwnProperty('practice_name') && practice.practice_name) {
                pName = practice.practice_name + ' #' + practice.practice_id;
            }

            billablePractices.push(
                <tr data-practice-id={practice.practice_id} data-practice-locations={practice.locations}
                    data-practice-setup-paid={practice.setup_paid} data-practice-do-not-bill={practice.do_not_bill} data-practice-sub-date={subDate.toLocaleDateString(locale)}
                    onClick={(e) => this.handlePracticeClick(e)}>
                    <th scope="row">
                        {pName}
                    </th>
                    <th>
                        {practice.locations}
                    </th>
                    <th>
                        {practice.setup_paid === 0 ? 'No' : 'Yes'}
                    </th>
                    <th>
                        {practice.do_not_bill === 0 ? 'No' : 'Yes'}
                    </th>
                    <th>
                        {subDate.toLocaleDateString(locale)}
                    </th>
                    <th>
                        <div className="d-flex flex-row p-2">
                            <Button color="primary" onClick={() => this.handlePracticeHistoryClick(practice)}>View History</Button>
                            <Button color="danger" className="ml-2" data-practice-id={practice.practice_id} onClick={(e) => this.handlePracticeUnsubscribeClick(e)}>Un-subscribe</Button>
                        </div>
                    </th>
                </tr>
            );
        }

        let historyModal = null;
        if (this.state.practiceHistory) {

            let orders = [];
            if (this.state.practiceHistory.hasOwnProperty('practice_orders') && this.state.practiceHistory.practice_orders) {
                for (let order of this.state.practiceHistory.practice_orders) {

                    let date = new Date(order.order_date);
                    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' };

                    orders.push(
                        <ListGroupItem className="activity-log-admin">
                            <ListGroupItemHeading>{date.toLocaleString("default", options)}</ListGroupItemHeading>
                            <ListGroupItemText>Order ID: {order.order_id}, Product #:{order.hsd_sku}</ListGroupItemText>
                        </ListGroupItem>
                    );
                }
            }

            historyModal  = (
                <Modal isOpen={this.state.historyModalState}>
                    <ModalHeader toggle={this.toggleHistoryModal}>Order History</ModalHeader>
                    <ModalBody>
                        <ListGroup>
                            {orders.length ? orders : '<h3>No orders placed on this practice yet</h3>'}
                        </ListGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={(e) => this.toggleHistoryModal()}>Close</Button>
                    </ModalFooter>
                </Modal>
            );
        }


        return (
            <div className="d-flex flex-column">
                <h3 className="section-title">Billing - Practices</h3>
                <Table hover>
                    <thead>
                        <th>Practice</th>
                        <th>Number of Locations</th>
                        <th>Setup paid?</th>
                        <th>Do not bill</th>
                        <th>Start Date</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>

                        <tr>
                            <th scope="row">
                                <Input type="text" name="new_practice_id" value={this.state.new_practice_id} onChange={(e) => this.handleChange(e)} placeholder="Practice ID..."/>
                            </th>
                            <th>
                                <Input type="number" name="new_practice_locations" value={this.state.new_practice_locations} onChange={(e) => this.handleChange(e)} placeholder="# of locations" />
                            </th>
                            <th className="mx-auto text-center">
                                <select className="text-center" name="new_practice_setup_paid" value={this.state.new_practice_setup_paid} onChange={(e) => this.handleChange(e)}>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </th>
                            <th className="mx-auto text-center">
                                <select className="text-center" name="new_practice_do_not_bill" value={this.state.new_practice_do_not_bill} onChange={(e) => this.handleChange(e)}>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </th>
                            <th>
                                Now
                            </th>
                            <th>
                                <Button color="primary" onClick={() => this.billNewPractice()}>{this.state.practiceButtonLabel}</Button>
                            </th>
                        </tr>

                        {billablePractices}

                    </tbody>
                </Table>
                {historyModal}
            </div>
        );

    }
}

export default AdminBilling;